import React from 'react';
import { Link } from 'react-router-dom';
import { useAppData } from '../../AppContext';
import '../admin.css';

const SHORTCUTS = [
  { to: '/admin/products',   icon: '⬡', label: 'Manage Products',   color: '#dbeafe', iconColor: '#1d4ed8' },
  { to: '/admin/hero',       icon: '▶', label: 'Edit Hero Slider',   color: '#dcfce7', iconColor: '#166534' },
  { to: '/admin/navigation', icon: '≡', label: 'Edit Navigation',    color: '#fef9c3', iconColor: '#854d0e' },
  { to: '/admin/dealers',    icon: '◎', label: 'Manage Dealers',     color: '#f3e8ff', iconColor: '#6b21a8' },
  { to: '/admin/resources',  icon: '⬇', label: 'Manage Resources',   color: '#ffedd5', iconColor: '#9a3412' },
  { to: '/admin/advantages', icon: '★', label: 'Edit Advantages',    color: '#ecfdf5', iconColor: '#065f46' },
  { to: '/admin/settings',   icon: '⚙', label: 'Site Settings',      color: '#f1f5f9', iconColor: '#475569' },
];

const Dashboard = () => {
  const { products, heroSlides, dealers, advantages, navItems } = useAppData();

  const stats = [
    { label: 'Products',    value: products.length,   color: '#2878c4', bg: '#dbeafe' },
    { label: 'Hero Slides', value: heroSlides.length,  color: '#166534', bg: '#dcfce7' },
    { label: 'Dealers',     value: dealers.length,     color: '#854d0e', bg: '#fef9c3' },
    { label: 'Advantages',  value: advantages.length,  color: '#6b21a8', bg: '#f3e8ff' },
    { label: 'Nav Items',   value: navItems.length,    color: '#9a3412', bg: '#ffedd5' },
  ];

  return (
    <div className='adm-page'>
      <div className='adm-header'>
        <div>
          <h1 className='adm-title'>Dashboard</h1>
          <p className='adm-subtitle'>Overview of your ZINGA® website content</p>
        </div>
      </div>

      {/* Stats */}
      <div className='adm-cards'>
        {stats.map(s => (
          <div className='adm-stat-card' key={s.label}>
            <div className='adm-stat-icon' style={{ background: s.bg }}>
              <svg width='20' height='20' viewBox='0 0 24 24' fill={s.color} stroke='none'>
                <rect x='3' y='3' width='18' height='18' rx='3'/>
              </svg>
            </div>
            <div className='adm-stat-label'>{s.label}</div>
            <div className='adm-stat-value'>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Quick actions */}
      <h2 style={{ fontSize: '1rem', fontWeight: 700, color: '#1a2a3a', marginBottom: '16px' }}>Quick Actions</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px,1fr))', gap: '16px', marginBottom: '32px' }}>
        {SHORTCUTS.map(s => (
          <Link
            key={s.to}
            to={s.to}
            style={{ textDecoration: 'none', background: '#fff', border: '1px solid #e8ecf0', borderRadius: '10px', padding: '20px', display: 'flex', flexDirection: 'column', gap: '12px', boxShadow: '0 1px 4px rgba(0,0,0,.04)', transition: 'box-shadow .18s, transform .18s' }}
            onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,.1)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,.04)'; e.currentTarget.style.transform = 'none'; }}
          >
            <div style={{ width: 40, height: 40, background: s.color, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem', color: s.iconColor }}>
              {s.icon}
            </div>
            <span style={{ fontSize: '.88rem', fontWeight: 700, color: '#1a2a3a' }}>{s.label}</span>
          </Link>
        ))}
      </div>

      {/* Info box */}
      <div style={{ background: '#edf5ff', border: '1px solid #c8e0f5', borderRadius: '10px', padding: '20px 24px', display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
        <span style={{ fontSize: '1.2rem' }}>ℹ️</span>
        <div>
          <strong style={{ color: '#1a4b7a', fontSize: '.88rem' }}>How it works</strong>
          <p style={{ color: '#4a6070', fontSize: '.83rem', margin: '6px 0 0', lineHeight: 1.6 }}>
            Changes made in this admin panel are saved to your browser's local storage and immediately reflected on the website. Use the sections above to manage your products, hero slider, navigation menu, dealer listings, resource documents and advantage cards.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
